import { withTranslation, WithTranslation } from 'react-i18next';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { handleInputWithLabelOnBlur, handleInputWithLabelOnFocus } from '../../registration';
import { OrganizationStep1FormResultKeys } from './organizationStep1FormModel';
import { IAccountModel } from '../../../../helpers/models/accountModel';
import { getDateMinimumString, handleCustomValidityOfDateField } from '../../../form/dateField';
import i18n from 'i18next';

export interface IOrganizationStep1AdditionalInformationProps extends WithTranslation {
    readonly?: boolean;
    account: IAccountModel;
}

const OrganizationStep1AdditionalInformation = (
    props: IOrganizationStep1AdditionalInformationProps
) => {
    const { t, readonly, account } = props;
    const [nonClinical, setNonClinical] = useState<boolean>(
        account.organization?.nonClinical || false
    );
    const [ownershipChange, setOwnershipChange] = useState<boolean>(
        account.organization?.ownershipChange || false
    );
    const [ownershipChangeDate, setOwnershipChangeDate] = useState<string>(
        account.organization
            ? account.organization?.ownershipChangeDate
                ? new Date(account.organization?.ownershipChangeDate ?? '')
                      .toISOString()
                      .split('T')[0]
                : ''
            : ''
    );
    const [legalNameChange, setLegalNameChange] = useState<boolean>(
        account.organization?.legalNameChange || false
    );
    const [legalNameChangeDate, setLegalNameChangeDate] = useState<string>(
        account.organization
            ? account.organization?.legalNameChangeDate
                ? new Date(account.organization?.legalNameChangeDate).toISOString().split('T')[0]
                : ''
            : ''
    );

    const handleLegalNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        const element = document.getElementById(
            OrganizationStep1FormResultKeys.CHANGE_DATE
        )! as HTMLInputElement;
        document.getElementById(
            'form_organization_step_1_enterprise_legal_name_change'
        )!.style.display = e.target.value === '1' ? 'flex' : 'none';

        if (e.target.value === '1') {
            element.setAttribute('required', '');
            element.parentElement?.focus();
        } else {
            element.removeAttribute('required');
            setLegalNameChangeDate('');
        }
    };

    const handlePropertyTranferChange = (e: ChangeEvent<HTMLInputElement>) => {
        const element = document.getElementById(
            OrganizationStep1FormResultKeys.PROPERTY_TRANSFER_DATE
        )! as HTMLInputElement;

        document.getElementById(
            'form_organization_step_1_enterprise_property_transfer'
        )!.style.display = e.target.value === '1' ? 'flex' : 'none';

        if (e.target.value === '1') {
            element.setAttribute('required', '');
            element.parentElement?.focus();
        } else {
            element.removeAttribute('required');
            setOwnershipChangeDate('');
        }
    };

    useEffect(() => {
        document.getElementById(
            'form_organization_step_1_enterprise_property_transfer'
        )!.style.display = ownershipChange ? 'flex' : 'none';

        document.getElementById(
            'form_organization_step_1_enterprise_legal_name_change'
        )!.style.display = legalNameChange ? 'flex' : 'none';
        updateDateFieldsCustomValidity();
    });

    useEffect(() => {
        updateDateFieldsCustomValidity();
    }, [i18n.language])

    const updateDateFieldsCustomValidity = () => {
        const ownershipDateField = (document.getElementById(OrganizationStep1FormResultKeys.PROPERTY_TRANSFER_DATE) as HTMLInputElement)!;
        const legalNameDateField = (document.getElementById(OrganizationStep1FormResultKeys.CHANGE_DATE) as HTMLInputElement)!;
        handleCustomValidityOfDateField(t, ownershipDateField, 'form_date_minimum_error', 'form_organization_step_1_date_ownership_empty_error');
        handleCustomValidityOfDateField(t, legalNameDateField, 'form_date_minimum_error', 'form_organization_step_1_date_legal_name_empty_error');
    }

    return (
        <>
            <h2 className="header-3 header-3--purple registration_form_header">
                {t('form_organization_step_1_complementary_title')}
            </h2>
            <div className="registration-organization-information-container">
                <div className="body-medium">
                    {t('form_organization_step_1_enterprise_clinical_environnement')}
                </div>
                <div className="registration-organization-checkbox-container">
                    <div className="radio-button-container">
                        <input
                            className="radio-button--input field-value"
                            type="radio"
                            value="1"
                            id="form_organization_step_1_enterprise_clinical_environnement_yes"
                            name={OrganizationStep1FormResultKeys.CLINICAL_ENV}
                            onBlur={handleInputWithLabelOnBlur}
                            onFocus={handleInputWithLabelOnFocus}
                            disabled={readonly}
                            checked={nonClinical}
                            onChange={(e) => e.target.checked && setNonClinical(true)}
                        />
                        <label
                            htmlFor="form_organization_step_1_enterprise_clinical_environnement_yes"
                            className={'radio-button radio-button--no-margin field-label registration-column-item '.concat(
                                readonly ? 'field-label--disabled' : ''
                            )}
                        >
                            <span className="accessibility-hidden">
                                {t('form_organization_step_1_complementary_title')
                                    .addSpace()
                                    .concat(
                                        t(
                                            'form_organization_step_1_enterprise_clinical_environnement'
                                        )
                                    )}
                            </span>
                            {t('form_organization_step_1_enterprise_clinical_environnement_yes')}
                        </label>
                    </div>
                    <div className="radio-button-container">
                        <input
                            className="radio-button--input field-value"
                            type="radio"
                            value="0"
                            id="form_organization_step_1_enterprise_clinical_environnement_no"
                            name={OrganizationStep1FormResultKeys.CLINICAL_ENV}
                            onBlur={handleInputWithLabelOnBlur}
                            onFocus={handleInputWithLabelOnFocus}
                            disabled={readonly}
                            checked={!nonClinical}
                            onChange={(e) => e.target.checked && setNonClinical(false)}
                        />
                        <label
                            htmlFor="form_organization_step_1_enterprise_clinical_environnement_no"
                            className={'radio-button radio-button--no-margin field-label registration-column-item '.concat(
                                readonly ? 'field-label--disabled' : ''
                            )}
                        >
                            <span className="accessibility-hidden">
                                {t('form_organization_step_1_complementary_title')
                                    .addSpace()
                                    .concat(
                                        t(
                                            'form_organization_step_1_enterprise_clinical_environnement'
                                        )
                                    )}
                            </span>
                            {t('form_organization_step_1_enterprise_clinical_environnement_no')}
                        </label>
                    </div>
                </div>
            </div>
            <div className="registration-organization-information-container">
                <div className="body-medium">
                    {t('form_organization_step_1_enterprise_property_transfer')}
                </div>
                <div className="registration-organization-checkbox-container">
                    <div className="radio-button-container">
                        <input
                            className="radio-button--input field-value"
                            type="radio"
                            value="1"
                            id="form_organization_step_1_enterprise_property_transfer_yes"
                            name={OrganizationStep1FormResultKeys.PROPERTY_TRANSFER}
                            onBlur={handleInputWithLabelOnBlur}
                            onFocus={handleInputWithLabelOnFocus}
                            onChange={(e) => {
                                handlePropertyTranferChange(e);
                                e.target.checked && setOwnershipChange(true);
                            }}
                            disabled={readonly}
                            checked={ownershipChange}
                        />
                        <label
                            htmlFor="form_organization_step_1_enterprise_property_transfer_yes"
                            className={'radio-button radio-button--no-margin field-label registration-column-item '.concat(
                                readonly ? 'field-label--disabled' : ''
                            )}
                        >
                            <span className="accessibility-hidden">
                                {t('form_organization_step_1_complementary_title')
                                    .addSpace()
                                    .concat(
                                        t('form_organization_step_1_enterprise_property_transfer')
                                    )}
                            </span>
                            {t('form_organization_step_1_enterprise_property_transfer_yes')}
                        </label>
                    </div>

                    <div className="radio-button-container">
                        <input
                            className="radio-button--input field-value"
                            type="radio"
                            value="0"
                            id="form_organization_step_1_enterprise_property_transfer_no"
                            name={OrganizationStep1FormResultKeys.PROPERTY_TRANSFER}
                            onBlur={handleInputWithLabelOnBlur}
                            onFocus={handleInputWithLabelOnFocus}
                            onChange={(e) => {
                                handlePropertyTranferChange(e);
                                e.target.checked && setOwnershipChange(false);
                            }}
                            disabled={readonly}
                            checked={!ownershipChange}
                        />
                        <label
                            htmlFor="form_organization_step_1_enterprise_property_transfer_no"
                            className={'radio-button radio-button--no-margin field-label registration-column-item '.concat(
                                readonly ? 'field-label--disabled' : ''
                            )}
                        >
                            <span className="accessibility-hidden">
                                {t('form_organization_step_1_complementary_title')
                                    .addSpace()
                                    .concat(
                                        t('form_organization_step_1_enterprise_property_transfer')
                                    )}
                            </span>
                            {t('form_organization_step_1_enterprise_property_transfer_no')}
                        </label>
                    </div>
                </div>
            </div>
            <div
                id="form_organization_step_1_enterprise_property_transfer"
                className="field-label registration-column-item registration-organization-radio-sub-field"
            >
                <label
                    className={'registration-organization-radio-sub-field-label '.concat(
                        readonly ? 'field-label--disabled' : ''
                    )}
                    htmlFor={OrganizationStep1FormResultKeys.PROPERTY_TRANSFER_DATE}
                    tabIndex={0}
                >
                    <span className="accessibility-hidden">
                        {t('form_organization_step_1_complementary_title')
                            .addSpace()
                            .concat(t('form_organization_step_1_enterprise_property_transfer'))}
                    </span>
                    {t('form_organization_step_1_enterprise_property_transfer_date')}
                </label>
                <input
                    className="field-value field-date"
                    type="date"
                    min={getDateMinimumString()}
                    name={OrganizationStep1FormResultKeys.PROPERTY_TRANSFER_DATE}
                    id={OrganizationStep1FormResultKeys.PROPERTY_TRANSFER_DATE}
                    readOnly={readonly}
                    value={ownershipChangeDate}
                    onChange={(e) => {
                        handleCustomValidityOfDateField(t, e.target, 'form_date_minimum_error', 'form_organization_step_1_date_ownership_empty_error');
                        setOwnershipChangeDate(e.target.value);
                    }}
                />
            </div>
            <div className="registration-organization-information-container">
                <div className="body-medium">
                    {t('form_organization_step_1_enterprise_legal_name_change')}
                </div>
                <div className="registration-organization-checkbox-container">
                    <div className="radio-button-container">
                        <input
                            className="radio-button--input field-value"
                            type="radio"
                            id="form_organization_step_1_enterprise_legal_name_change_yes"
                            name={OrganizationStep1FormResultKeys.LEGAL_NAME_CHANGE}
                            value="1"
                            onBlur={handleInputWithLabelOnBlur}
                            onFocus={handleInputWithLabelOnFocus}
                            onChange={(e) => {
                                handleLegalNameChange(e);
                                e.target.checked && setLegalNameChange(true);
                            }}
                            disabled={readonly}
                            checked={legalNameChange}
                        />
                        <label
                            htmlFor="form_organization_step_1_enterprise_legal_name_change_yes"
                            className={'radio-button radio-button--no-margin field-label registration-column-item '.concat(
                                readonly ? 'field-label--disabled' : ''
                            )}
                        >
                            <span className="accessibility-hidden">
                                {t('form_organization_step_1_complementary_title')
                                    .addSpace()
                                    .concat(
                                        t('form_organization_step_1_enterprise_legal_name_change')
                                    )}
                            </span>
                            {t('form_organization_step_1_enterprise_legal_name_change_yes')}
                        </label>
                    </div>

                    <div className="radio-button-container">
                        <input
                            className="radio-button--input field-value"
                            type="radio"
                            id="form_organization_step_1_enterprise_legal_name_change_no"
                            name={OrganizationStep1FormResultKeys.LEGAL_NAME_CHANGE}
                            value="0"
                            onBlur={handleInputWithLabelOnBlur}
                            onFocus={handleInputWithLabelOnFocus}
                            onChange={(e) => {
                                handleLegalNameChange(e);
                                e.target.checked && setLegalNameChange(false);
                            }}
                            disabled={readonly}
                            checked={!legalNameChange}
                        />
                        <label
                            htmlFor="form_organization_step_1_enterprise_legal_name_change_no"
                            className={'radio-button radio-button--no-margin field-label registration-column-item '.concat(
                                readonly ? 'field-label--disabled' : ''
                            )}
                        >
                            <span className="accessibility-hidden">
                                {t('form_organization_step_1_complementary_title')
                                    .addSpace()
                                    .concat(
                                        t('form_organization_step_1_enterprise_legal_name_change')
                                    )}
                            </span>
                            {t('form_organization_step_1_enterprise_legal_name_change_no')}
                        </label>
                    </div>
                </div>
            </div>
            <div
                id="form_organization_step_1_enterprise_legal_name_change"
                className="field-label registration-column-item registration-organization-radio-sub-field"
            >
                <label
                    className={'registration-organization-radio-sub-field-label '.concat(
                        readonly ? 'field-label--disabled' : ''
                    )}
                    htmlFor={OrganizationStep1FormResultKeys.CHANGE_DATE}
                    tabIndex={0}
                >
                    <span className="accessibility-hidden">
                        {t('form_organization_step_1_complementary_title')
                            .addSpace()
                            .concat(t('form_organization_step_1_enterprise_legal_name_change'))}
                    </span>
                    {t('form_organization_step_1_enterprise_legal_name_change_date')}
                </label>
                <input
                    className="field-value field-date"
                    name={OrganizationStep1FormResultKeys.CHANGE_DATE}
                    id={OrganizationStep1FormResultKeys.CHANGE_DATE}
                    type="date"
                    min={getDateMinimumString()}
                    readOnly={readonly}
                    value={legalNameChangeDate}
                    onChange={(e) => {
                        handleCustomValidityOfDateField(t, e.target, 'form_date_minimum_error', 'form_organization_step_1_date_legal_name_empty_error');
                        setLegalNameChangeDate(e.target.value);
                    }}
                />
            </div>
        </>
    );
};

export default withTranslation()(OrganizationStep1AdditionalInformation);
